import { useSelector } from 'react-redux';
import { selectMenuIndex } from '../../store/menuOrder/menuOrderSlice';

// The menu index the cart sorts by (spec 2026-10-12 §4.3): the one of the
// store the basket belongs to, which is not always the store whose page is
// open; a basket with no store recorded yet uses the page's store.
const useBasketMenuIndex = () =>
  useSelector((state) =>
    selectMenuIndex(
      state,
      state.basket?.basket?.basketStore?.storeSlug ||
        state.base?.common?.currentStore?.slug,
    ),
  );

export default useBasketMenuIndex;
